export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Header.vue?vue&type=template&id=0bfce040&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/Header.vue?vue&type=template&id=0bfce040&
// module id = null
// module chunks = 